import { RelativeDateRange } from "@portal/util/relative-date-range";
import { useState } from "react";
import {
  CustomFieldBetweenValues,
  CustomFieldFilterValues,
  CustomFieldOperatorType,
} from "../../../../types/entities/custom-field";
import { DateRangeElement } from "../DateRange/DateRangeElement";
import { DateRangeString } from "../DateRange/type";
import { getDateRangeFromSelectedValue } from "./predicate";

export interface DateSelectedValue {
  value: CustomFieldBetweenValues;
  type: CustomFieldOperatorType;
  include_unassigned: boolean;
  date_range?: RelativeDateRange;
}

export interface CustomFieldDateFilterProps {
  value?: DateSelectedValue;
  onCancel: () => void;
  onSubmit: (value: Omit<CustomFieldFilterValues<"BTWN">, "id">) => void;
}

const defaultValue: DateSelectedValue = {
  type: "BTWN",
  include_unassigned: false,
  value: { from: "", to: "" },
};
function CustomFieldDateFilter(props: CustomFieldDateFilterProps) {
  const { value, onCancel, onSubmit } = props;
  const [selectedValue, setSelectedValue] = useState<
    DateSelectedValue | undefined
  >(value || defaultValue);

  function handleDateRangeChange(dateRange: DateRangeString) {
    const from = dateRange.from || "";
    const to = dateRange.to || "";

    setSelectedValue({
      value: {
        from,
        to,
      },
      type: "BTWN",
      include_unassigned: false,
      date_range: dateRange.type as RelativeDateRange,
    });
  }

  function handleSubmit() {
    if (selectedValue) {
      const values: Omit<CustomFieldFilterValues<"BTWN">, "id"> = {
        operator: {
          type: "BTWN",
          operands: {
            type: "DEPRECATED_ABSOLUTE",
            value: selectedValue.value as CustomFieldBetweenValues,
          },
        },
        include_unassigned: false,
        date_range: selectedValue.date_range,
      };
      onSubmit(values);
    }
  }

  const initialValue = getDateRangeFromSelectedValue(selectedValue);

  return (
    <>
      <DateRangeElement
        value={initialValue}
        onSubmit={handleSubmit}
        onCancel={onCancel}
        onChange={handleDateRangeChange}
      />
    </>
  );
}

export { CustomFieldDateFilter };
